module.exports = __webpack_public_path__ + "img/user.28deef79.svg";